import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as toastrReducer } from 'react-redux-toastr';
// General reducers
import config from './shared/ducks/config';
import fileUpload from './components/FileUpload/fileupload';
import entities from './shared/ducks/entities';
import error from './shared/ducks/error';
import session, { USER_LOGOUT_SUCCESS } from './shared/ducks/session';
import events from './shared/ducks/events';

const appReducer = combineReducers({
    config,
    error,
    events,
    fileUpload,
    entities,
    routing: routerReducer,
    session,
    toastr: toastrReducer,
});

const rootReducer = (state, action) => {
    // Reset our entire state to the predefined initialState for each reducer when logging out.
    // This way no cached data is visible to a user that logs in after another user logs out.
    if (action.type === USER_LOGOUT_SUCCESS) {
        // If state passed to reducers is set to "undefined", by default they will be assigned the initial state object
        state.entities = undefined;
        state.error = undefined;
        state.events = undefined;
        state.fileUpload = undefined;
        state.session = undefined;
        state.toastr = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
